import React, { useState, useRef} from 'react';
import { IonGrid, IonRow, IonCol, IonInput, IonHeader, IonTitle, IonToolbar, IonButton, IonContent, IonList, IonItem, IonSlides, IonSlide, IonModal } from '@ionic/react';


import {ClientLoginCredentials } from '../components/LoginCredentials_client'
//import { AuthenticatedClientProvider } from '../../../storeState/auth_clientID_context'


export function UserLogin () {

    //alert('In UserLogin');

    let [ccInfoDropdown, setCCInfoDropdown ] = useState('none');
    let [mmInfoDropdown, setMMInfoDropdown ] = useState('none');
    let [checkingInfoDropdown, setCheckingInfoDropdown ] = useState('none');
    let [cashInfoDropdown, setCashInfoDropdown ] = useState('none');

    let [showCreateAccount, setShowCreateAccount] = useState(false);

    let usernameInputChangeRef = useRef();
    let passwordInputChangeRef = useRef();
    let createFirstNameRef = useRef();
    let createLastNameRef = useRef();
    let createMobileNumberRef = useRef();
    let createEmailRef = useRef();
    let createAddressRef = useRef();
    let createCityRef = useRef();
    let createRegionRef = useRef();
    let createCountryRef = useRef();
    let createClosestLandmarkRef = useRef();
    let createTaxIDRef = useRef();
    let createUsernameRef = useRef();
    let createPasswordRef = useRef();

    /*let createCC_numberRef = useRef();
    let createCC_serviceCodeRef = useRef();
    let createCC_expDateRef = useRef();
    let createCC_addressRef = useRef();
    let createCC_cityRef = useRef();
    let createCC_stateRef = useRef();
    let createCC_zipRef = useRef();
    let createCC_cvvNumberRef = useRef();

    let createMM_providerRef = useRef();
    let createMM_numberRef = useRef();
    
    let createChecking_acctNameRef = useRef();
    let createChecking_acctNumberRef = useRef();
    let createChecking_routingNumberRef = useRef();
    let createChecking_bankNameRef = useRef();
    let createChecking_bankBranchRef = useRef();
    
    let create_cashPinRef = useRef();*/



  function handleCreateAccount() {

      const requestOptions = {
          method: 'POST',
          headers: {
              'Accept': 'text/html, application/json',
              'content-type': 'application/json',
           },
          body: JSON.stringify({
              Tracker: '73001',
              uFirstName: createFirstNameRef.current.value,
              uLastName: createLastNameRef.current.value,
              uMobileNumber: createMobileNumberRef.current.value,
              uEmail: createEmailRef.current.value,
              uAddress: createAddressRef.current.value,
              uCity: createCityRef.current.value,
              uRegion: createRegionRef.current.value,
              uCountry: createCountryRef.current.value,
              uClosestLandmark: createClosestLandmarkRef.current.value,
              uTaxID: createTaxIDRef.current.value,
              uUsername: createUsernameRef.current.value,
              uPassword: createPasswordRef.current.value,
              /*uCreditCardNumber: createCC_numberRef.current.value,
              uCreditCardServiceCode: createCC_serviceCodeRef.current.value,
              uCreditCardExpDate: createCC_expDateRef.current.value,
              uCreditCardAddress: createCC_addressRef.current.value,
              uCreditCardCity: createCC_cityRef.current.value,
              uCreditCardState: createCC_stateRef.current.value,
              uCreditCardZip: createCC_zipRef.current.value,
              uCreditCardCvvNumber: createCC_cvvNumberRef.current.value,
              uMobileMoneyProvider: createMM_providerRef.current.value,
              uMobileMoneyNumber: createMM_numberRef.current.value,
              uEnterCheckingBankName: createChecking_bankNameRef.current.value,
              uEnterCheckingBankBranch: createChecking_bankBranchRef.current.value,
              uEnterCheckingBankAcctName: createChecking_acctNameRef.current.value,
              uEnterCheckingAcctNumber: createChecking_acctNumberRef.current.value,
              uEnterCheckingRoutingNumber: createChecking_routingNumberRef.current.value,
              uCashPin: create_cashPinRef.current.value,*/
          })
      }

      fetch("https://ghanaverified.com/users_argsjqApp",requestOptions)
      .then(res => res.text())
      .then(res => {
          
          alert(res);


          setShowCreateAccount(false);

      })


  }



  function handleDropdown_cc(e) 
  { 
      let checkbox = document.getElementById('ccInfoDropdown');

      if(checkbox.checked == true)
      {
        setCCInfoDropdown('inline-block');
      }
      else
      {
        setCCInfoDropdown('none');
      }
  }
  function handleDropdown_mm(e) 
  { 
      let checkbox = document.getElementById('mmInfoDropdown');

      if(checkbox.checked == true)
      {
        setMMInfoDropdown('inline-block');
      }
      else
      {
        setMMInfoDropdown('none');
      }
  }
  function handleDropdown_checking(e) 
  { 
      let checkbox = document.getElementById('checkingInfoDropdown');

      if(checkbox.checked == true)
      {
        setCheckingInfoDropdown('inline-block');

      }
      else
      {
        setCheckingInfoDropdown('none');

      }
  }
  function handleDropdown_cash(e) 
  { 
      let checkbox = document.getElementById('cashInfoDropdown');

      if(checkbox.checked == true)
      {
        setCashInfoDropdown('inline-block');
      }
      else
      {
        setCashInfoDropdown('none');
      }
  }

    //const xTracker = this.state.Tracker;
    //const xUsername = this.state.pUsername;
    //const xPassword = this.state.pPassword;

    //const username = this.props.zUsername;
    //const password = this.props.zPassword;

    return (
      //<IonPage>
      //<div className='ion-page'>
      <React.Fragment>
        {/*<IonHeader>
          <IonToolbar>
            <IonTitle size="large" class="appTitle">QAVA</IonTitle>
            <IonTitle size="small" class="appTitle"> Invoice and Forms </IonTitle>
            <IonButton class="homeToolbarButtons" routerLink='/home'> Home </IonButton>
            <IonButton class="homeToolbarButtons" routerLink='/merchantLogin'> Merchants </IonButton>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonHeader>*/}
            <IonList class="homeList">
              <IonItem class="searchUsersHome">
                   <ClientLoginCredentials  />
              </IonItem>
              <IonModal id='createAccountModal' isOpen={showCreateAccount}>
                <IonGrid class='gridTabSliderCustom'>
                    <IonRow>
                        <IonCol> Personal Information </IonCol>
                        <IonCol> Payment Methods</IonCol>
                    </IonRow>
                </IonGrid>
                <IonSlides>
                    <IonSlide>
                        <IonGrid  class='gridText'>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>First Name: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter First Name' ref={createFirstNameRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Last Name: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Last Name' ref={createLastNameRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Mobile Number: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Company Phone Number' ref={createMobileNumberRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Email: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Email Address' ref={createEmailRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Address: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Physical Address' ref={createAddressRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>City: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter City' ref={createCityRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Region: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Region' ref={createRegionRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Country: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Country' ref={createCountryRef}></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Closest Landmark: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Closest Landmark' ref={createClosestLandmarkRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Tax ID Number: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Enter Tax ID' ref={createTaxIDRef }></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Create a username: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Create Username' ref={createUsernameRef}></IonInput></IonCol>
                            </IonRow>
                            <IonRow class='gridResultBody'>
                                <IonCol class='gridResultColumns'>Create a password: </IonCol>
                                <IonCol class='gridResultColumns'><IonInput placeholder='Create Password' ref={createPasswordRef }></IonInput></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonSlide>
                    {/*<IonSlide>
                        <label for='ccInfoDropdown'> Credit Card </label>
                            <input type='checkbox' id='ccInfoDropdown' onChange={(e) => handleDropdown_cc(e)}></input>
                            <IonGrid  class='gridText' style={{display: ccInfoDropdown}}>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Credit Card Number: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Card Number' ref={createCC_numberRef}></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Service Code: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Service Code' ref={createCC_serviceCodeRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Expiration Date: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Expiration Date' ref={createCC_expDateRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Card Address: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Card Address' ref={createCC_addressRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Card City: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Card City' ref={createCC_cityRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Card State: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Card State' ref={createCC_stateRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Card Zip: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Card Zip' ref={createCC_zipRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Card Cvv Number: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Cvv' maxlength='3' ref={createCC_cvvNumberRef}></IonInput></IonCol>
                                </IonRow>
                            </IonGrid>
                        <label for='mmInfoDropdown'>Mobile Money</label>
                            <input type='checkbox' id='mmInfoDropdown' onChange={(e) => handleDropdown_mm(e)}></input>
                            <IonGrid  class='gridText' style={{display: mmInfoDropdown}}>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Mobile Money Provider: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Mobile Money Provider' ref={createMM_providerRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Mobile Money Number: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Mobile Money Number' ref={createMM_numberRef }></IonInput></IonCol>
                                </IonRow>
                            </IonGrid>
                        <label for='checkingInfoDropdown'>Checking Account</label>
                            <input type='checkbox' id='checkingInfoDropdown' onChange={(e) => handleDropdown_checking(e)}></input>
                            <IonGrid  class='gridText' style={{display: checkingInfoDropdown}}>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Bank Name: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Name' ref={createChecking_bankNameRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Bank Branch Location: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Branch Name' ref={createChecking_bankBranchRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Bank Account Name: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Account Name' ref={createChecking_acctNameRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Bank Account Number: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Account Number (10 characters max)' maxlength='10' ref={createChecking_acctNumberRef }></IonInput></IonCol>
                                </IonRow>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Bank Routing Number: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Routing Number (9 characters exact)' maxlength='9' ref={createChecking_routingNumberRef }></IonInput></IonCol>
                                </IonRow>
                            </IonGrid>
                        <label for='cashInfoDropdown'>Cash</label>
                            <input type='checkbox' id='cashInfoDropdown' onChange={(e) => handleDropdown_cash(e)}></input>
                            <IonGrid  class='gridText' style={{display: cashInfoDropdown}}>
                                <IonRow class='gridResultBody'>
                                    <IonCol class='gridResultColumns'>Cash Pin: </IonCol>
                                    <IonCol class='gridResultColumns'><IonInput placeholder='Enter Bank Name' ref={create_cashPinRef }></IonInput></IonCol>
                                </IonRow>
                            </IonGrid>
                    </IonSlide>*/}
                </IonSlides>
                <IonButton onClick={ handleCreateAccount }>Submit</IonButton>
                <IonButton onClick={() => setShowCreateAccount(false)}>Close Modal</IonButton>
            </IonModal>
            <IonButton onClick={() => setShowCreateAccount(true)}>
                    Create Account
            </IonButton>
            </IonList>
          {/*</IonHeader>
        </IonContent>*/}
        </React.Fragment>
        //</div>
      //</IonPage>
  );
};


export default UserLogin;